import React from 'react';
import { UserIcon, UsersIcon, BuildingIcon } from 'lucide-react';
export function WhoThisIsFor() {
  const audiences = [{
    icon: UserIcon,
    title: 'Senior Leaders & Founders',
    empathy: 'If you feel like AI is moving faster than your ability to lead through it...',
    outcomes: ['A clear AI strategy that aligns with your business goals', 'Confidence to speak about AI with boards and investors', 'Personal AI workflow that saves 10+ hours per week', 'A 90-day action plan you can start Monday']
  }, {
    icon: UsersIcon,
    title: 'Leadership Teams',
    empathy: 'If your team is fragmented on AI—some excited, some skeptical, all confused...',
    outcomes: ['Shared AI language and mental models across functions', 'Team-built prototypes and workflows ready to deploy', 'Aligned 12-month AI roadmap with clear owners', 'Culture shift from fear to experimentation']
  }, {
    icon: BuildingIcon,
    title: 'Corporate Cohorts',
    empathy: 'If your company needs to accelerate AI adoption at scale, with governance...',
    outcomes: ['Private track customized to your industry and challenges', 'Pre-bootcamp diagnostic and post-bootcamp implementation support', 'Board-ready AI strategy and risk briefing', 'Internal champions equipped to lead the transformation']
  }];
  return <section className="py-24" data-id="element-390">
      <div className="max-w-7xl mx-auto px-6" data-id="element-391">
        <div className="text-center mb-16" data-id="element-392">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-393">
            Who This Is For
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-394">
            Whether you're a solo leader catching up, a team getting aligned, or
            a company transforming at scale
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-395">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-8 hover:border-cyan-500/50 transition-all duration-300" data-id="element-396">
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-purple-500 rounded-lg flex items-center justify-center mb-6" data-id="element-397">
                  <Icon className="w-7 h-7 text-white" data-id="element-398" />
                </div>

                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-399">
                  {audience.title}
                </h3>

                <p className="text-slate-400 italic mb-6 leading-relaxed" data-id="element-400">
                  {audience.empathy}
                </p>

                <div className="space-y-3" data-id="element-401">
                  <p className="text-sm font-semibold text-cyan-400 uppercase tracking-wider" data-id="element-402">
                    You will leave with:
                  </p>
                  {audience.outcomes.map((outcome, i) => <div key={i} className="flex items-start gap-3" data-id="element-403">
                      <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full mt-2 flex-shrink-0" data-id="element-404"></div>
                      <p className="text-slate-300" data-id="element-405">{outcome}</p>
                    </div>)}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}